import dataService from "../../api";

import { serverErrorMessage, showAlert, catchHandler } from "@/utils/helpers";
// startLoading, stopLoading, showNotification,

export default {
    namespaced: true,
    state: {
        lookups: [],
        doctors: [],
        departments: [],
        reasons: [],
        medicines: [],
        suppliers: [],
        services: [],
        subServices: [],
        analysis: [],
        specialties: [],
        stores: [],
        itemPriceList: [],
        paymentAccounts: [],
        procedures: [],


    },
    getters: {
        getLookupByType: state => lookupType => state.lookups.filter((lookup) => lookup.type == lookupType),
        getServicesByType: state => Type => state.subServices.filter((i) => i.type == Type),
    },
    mutations: {
        setLookups: (state, t) => (state.lookups = t),
        setDoctors: (state, t) => (state.doctors = t),
        setDepartments: (state, t) => (state.departments = t),
        setReasons: (state, t) => (state.reasons = t),
        setMedicines: (state, t) => (state.medicines = t),
        setSuppliers: (state, t) => (state.suppliers = t),
        setServices: (state, t) => (state.services = t),
        setSubServices: (state, t) => (state.subServices = t),
        setAnalysis: (state, t) => (state.analysis = t),
        setSpecialties: (state, t) => (state.specialties = t),
        setStores: (state, t) => (state.stores = t),
        setItemPriceList: (state, t) => (state.itemPriceList = t),
        setProcedures: (state, t) => (state.procedures = t),
        setPaymentAccounts: (state, t) => (state.paymentAccounts = t),

    },
    actions: {
        async getLookups({ commit }) {
            try {
                const response = await dataService.lookups.getLookups();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const lookups = response.data.lookups;
                commit("setLookups", lookups);

            } catch (error) {
                catchHandler(error);
            }
        },
        async getDoctors({ commit }) {
            try {
                const response = await dataService.lookups.getDoctors();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const doctors = response.data.doctors;
                commit("setDoctors", doctors);

            } catch (error) {
                catchHandler(error);
            }
        },
        async getReasons({ commit }, id) {
            try {
                const response = await dataService.lookups.getReasons(id);

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const reasons = response.data.reasons;
                commit("setReasons", reasons);

            } catch (error) {
                catchHandler(error);
            }
        },
        async getDepartments({ commit }) {
            try {
                const response = await dataService.lookups.getDepartments();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const departments = response.data.departments;
                commit("setDepartments", departments);

            } catch (error) {
                catchHandler(error);
            }
        },
        async getMedicines({ commit }) {
            try {
                const response = await dataService.lookups.getMedicines();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const medicines = response.data.medicines;
                commit("setMedicines", medicines);

            } catch (error) {
                catchHandler(error);
            }
        },
        async getPharmacyMedicines({ commit }) {
            try {
                const response = await dataService.lookups.getPharmacyMedicines();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const medicines = response.data.medicines;
                commit("setMedicines", medicines);

            } catch (error) {
                catchHandler(error);
            }
        },
        async getSuppliers({ commit }) {
            try {
                const response = await dataService.lookups.getSuppliers();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const suppliers = response.data.suppliers;
                commit("setSuppliers", suppliers);

            } catch (error) {
                catchHandler(error);
            }
        },

        async getServices({ commit }) {
            try {
                const response = await dataService.lookups.getServices();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const services = response.data.services;
                commit("setServices", services);

            } catch (error) {
                catchHandler(error);
            }
        },

        async getSubServices({ commit }) {
            try {
                const response = await dataService.lookups.getSubServices();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const services = response.data.services;
                commit("setSubServices", services);

            } catch (error) {
                catchHandler(error);
            }
        },
        async getAnalysis({ commit }, id) {
            try {
                const response = await dataService.lookups.getAnalysis(id);

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const analysis = response.data.analysis;
                commit("setAnalysis", analysis);

            } catch (error) {
                catchHandler(error);
            }
        },
        async getSpecialties({ commit }, id) {
            try {
                const response = await dataService.lookups.getSpecialties(id);

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const specialties = response.data.specialties;
                commit("setSpecialties", specialties);

            } catch (error) {
                catchHandler(error);
            }
        },
        async getStores({ commit }) {
            try {
                const response = await dataService.lookups.getStores();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const stores = response.data.stores;
                commit("setStores", stores);

            } catch (error) {
                catchHandler(error);
            }
        },
        ///erp service
        async getPaymentAccounts({ commit }) {
            try {
                const response = await dataService.lookups.getPaymentAccounts();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                const paymentAccounts = response.data.paymentAccounts;
                commit("setPaymentAccounts", paymentAccounts);

            } catch (error) {
                catchHandler(error);
            }
        },
        async getAllItem({ commit }, name) {
            try {
                const response = await dataService.lookups.getAllItem(name);

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                const itemPriceList = response.data.allprices;
                commit("setItemPriceList", itemPriceList); // ✅ هذا صحيح

            } catch (error) {
                catchHandler(error);
            }
        },
        async getAllItemPriceList({ commit }, name) {
            try {
                const response = await dataService.lookups.getAllItemPriceList(name);

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                const itemPriceList = response.data.allprices;
                commit("setItemPriceList", itemPriceList); // ✅ هذا صحيح

            } catch (error) {
                catchHandler(error);
            }
        },
        async GetItemByProcedure({ commit }, name) {
            try {
                const response = await dataService.lookups.GetItemByProcedure(name);

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                const itemPriceList = response.data.allprices;
                commit("setItemPriceList", itemPriceList); // ✅ هذا صحيح

            } catch (error) {
                catchHandler(error);
            }
        },
        async getProcedures({ commit }) {
            try {
                const response = await dataService.lookups.getProcedures();

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                const procedures = response.data.data.filter(x => x.value != "الاصول الثابتة" &&  x.value !=  "خدمات تحاليل");
                commit("setProcedures", procedures); // ✅ هذا صحيح

            } catch (error) {
                catchHandler(error);
            }
        }
    }
};
